import { ev } from "../util";

export enum HomeBannerType {
    BANNER_TOP = ev('BANNER_TOP', 1),
    BANNER_BOTTOM = ev('BANNER_BOTTOM', 2),
}